import { trackElementInteraction } from '@/common/analytics/gtm/shared/trackElementInteraction';

export const trackMorePostersBtn = (elementId: string): void => {
  trackElementInteraction({ elementId });
};

export const trackFeedToggle = (elementVariant: string): void => {
  trackElementInteraction({
    elementId: 'recommendation_feed_toggle',
    elementVariant,
  });
};
